
import { useState, useEffect } from 'react';
import { Invoice } from '@/types/payments';

export function useInvoiceState(initialInvoices: Invoice[]) {
  const [invoices, setInvoices] = useState<Invoice[]>(initialInvoices);
  const [selectedInvoices, setSelectedInvoices] = useState<string[]>([]);
  
  // Update invoices when initialInvoices changes
  useEffect(() => {
    setInvoices(initialInvoices);
  }, [initialInvoices]);

  const toggleSelectInvoice = (invoiceId: string) => {
    setSelectedInvoices((prevSelected) =>
      prevSelected.includes(invoiceId)
        ? prevSelected.filter((id) => id !== invoiceId)
        : [...prevSelected, invoiceId]
    );
  };

  const toggleSelectAll = (filteredInvoices: Invoice[]) => {
    const allSelected = selectedInvoices.length === filteredInvoices.length && filteredInvoices.length > 0;

    if (allSelected) {
      setSelectedInvoices([]);
    } else {
      setSelectedInvoices(filteredInvoices.map((invoice) => invoice.id));
    }
  };

  return {
    invoices,
    setInvoices,
    selectedInvoices,
    setSelectedInvoices,
    toggleSelectInvoice,
    toggleSelectAll,
  };
}
